export default {
	"1630b6b6ad76b424e048fdb1a557976b": "苹果支付",
	"eb0d5a7799b129f06512c166d0268563": "谷歌支付",
	"e738a4caf17b913853b4a71a6bc9ef47": "参数错误!",
	"397eb0a681632c476010ab12553d0647": "签约中...",
	"a6d6b6694979b1225ca56e57a8ca4b80": "支付中...",
	"7ec39eb7726bd374fca9faf82c2dc7ac": "您确定要放弃支付吗？",
	"f382c25c78cd507886f788fc5ac67d02": "支付结果确认中",
	"73fd929b5f73dd4b0671ab94ab824273": "请勿重复支付或离开此页面哦"
}
